import franchiseList from './franchiseList/franchiseListSlice';
import groupLogos from './groupLogos/groupLogosSlice';

const root = {
	franchiseList,
	groupLogos
};

export default root;
